import { isUndefined } from 'lodash-es';

import { ChartOverlaysBorder } from '../../../core/components/overlays/ChartOverlaysBorder.js';
import { useAnnotationsConfig } from '../../hooks/useAnnotationsConfig.js';
import { useYScales } from '../../hooks/useYScales.js';

export const TimeseriesChartOverlaysBorder = () => {
  const { left, right } = useYScales();
  const { tracks } = useAnnotationsConfig();
  const visibleTracksCount = tracks.filter((track) => !track.hidden).length;

  return (
    <ChartOverlaysBorder
      left={!isUndefined(left)}
      right={!isUndefined(right)}
      bottom
      topSeparator={visibleTracksCount > 1}
    />
  );
};
